import _Map from "babel-runtime/core-js/map";
import _toConsumableArray from "babel-runtime/helpers/toConsumableArray";
import _getIterator from "babel-runtime/core-js/get-iterator";
import _slicedToArray from "babel-runtime/helpers/slicedToArray";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _createClass from "babel-runtime/helpers/createClass";

var SplitCacheInMemory = function () {
  function SplitCacheInMemory() {
    _classCallCheck(this, SplitCacheInMemory);

    this.flush();
  }

  _createClass(SplitCacheInMemory, [{
    key: "addSplit",
    value: function addSplit(splitName, split) {
      this.splitCache.set(splitName, split);

      return true;
    }
  }, {
    key: "addSplits",
    value: function addSplits(entries) {
      var results = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(entries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          results.push(this.addSplit(key, value));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return results;
    }
  }, {
    key: "removeSplit",
    value: function removeSplit(splitName) {
      this.splitCache.delete(splitName);

      return 1;
    }
  }, {
    key: "removeSplits",
    value: function removeSplits(splitNames) {
      var _this = this;

      splitNames.forEach(function (n) {
        return _this.splitCache.delete(n);
      });

      return splitNames.length;
    }
  }, {
    key: "getSplit",
    value: function getSplit(splitName) {
      return this.splitCache.get(splitName);
    }
  }, {
    key: "setChangeNumber",
    value: function setChangeNumber(changeNumber) {
      this.changeNumber = changeNumber;

      return true;
    }
  }, {
    key: "getChangeNumber",
    value: function getChangeNumber() {
      return this.changeNumber;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return [].concat(_toConsumableArray(this.splitCache.values()));
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return [].concat(_toConsumableArray(this.splitCache.keys()));
    }
  }, {
    key: "flush",
    value: function flush() {
      this.splitCache = new _Map();
      this.changeNumber = -1;
    }
  }]);

  return SplitCacheInMemory;
}();

export default SplitCacheInMemory;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/storage/SplitCache/InMemory.js
// module id = null
// module chunks = 